/**
 * Created by Christof Sander on 27.09.2016.
 */

const utils = require('frontend-controller/lib/utils')

module.exports = {
	extends: [
		'/',
		'templates',
		'privilegeTrees',
		'privilegeTrees'
	],

	config: {
		treeTypeComponents: {
			default: [
				'/',
				'templates',
				'privilegeTrees',
				'selectPrivilegeTree'
			]
		}
	},

	actions: {
		addTree: {
			source: {
				load: {
					componentData: {
						config: {
							lastMileSelector: 'section.filterContent section.colWrap',
						}
					}
				}
			}
		}
	},

	methods: {
		// TODO: DOC!
		getSelectionPrivileges: function(allPrivileges, rolePrivileges, userPrivileges){
			var result = {
				checked: [],
				unchecked: [],
				nrOfPrivilegesDeniedByUser: 0,
				nrOfPrivilegesAllowedByUser: 0
			};
			var privileges = {
				role: {},
				user: {}
			};
			var self = this;
			var hasPrivilegeEntry, isBlackListElement;

			utils.forEach(rolePrivileges, function(rolePrivilege){
				privileges.role[rolePrivilege.attributes.privilegeID] = rolePrivilege.attributes;
			});
			utils.forEach(userPrivileges, function(userPrivilege){
				privileges.user[userPrivilege.attributes.privilegeID] = userPrivilege.attributes;
			});

			utils.forEach(allPrivileges, function(privilege){
				hasPrivilegeEntry = privileges.role[privilege.id];
				isBlackListElement = self.isBlackListPrivilege(privilege.code);

				// // NOTE: global negation used to increase code clearness
				// if(
				// 	(
				// 		privileges.role[privilege.id]
				// 		&&
				// 		privileges.user[privilege.id]
				// 		&&
				// 		!privileges.user[privilege.id].hasPrivilege
				// 	)
				// 	||
				// 	(
				// 		!privileges.role[privilege.id]
				// 		&&
				// 		(
				// 			!privileges.user[privilege.id]
				// 			||
				// 			!privileges.user[privilege.id].hasPrivilege
				// 		)
				// 	)
				// ){
				// 	result.unchecked.push(privilege.id);
				// 	if(privileges.user[privilege.id]) result.nrOfPrivilegesDeniedByUser++;
				// }
				// else {
				// 	result.checked.push(privilege.id);
				// 	if(
				// 		privileges.user[privilege.id]
				// 		&&
				// 		privileges.user[privilege.id].hasPrivilege
				// 	){
				// 		result.nrOfPrivilegesAllowedByUser++;
				// 	}
				// }

				if(
					(hasPrivilegeEntry && !isBlackListElement)
					||
					(!hasPrivilegeEntry && isBlackListElement)
				){
					result.checked.push(privilege.id);
				}
				else {
					result.unchecked.push(privilege.id);
				}
			});

			return result;
		},

		preSelectPrivileges: function(rolePrivileges, userPrivileges, autoSelect){
			var self = this;
			var privilegeInfo = {
				nrOfPrivileges:     0,
				nrOfRolePrivileges: 0,
				nrOfUserPrivileges: 0
			};

			// select right privileges if necessary
			var privileges = self.getSelectionPrivileges(
				self.registry[0].tree.resourceData.treeData.nodes,
				rolePrivileges,
				userPrivileges
			);
			var treeComponentIndex = Object.keys(self.model.states.trees).shift();

			utils.map(privileges.checked, function (privilege) {
				return self.getNodeIndex(privilege, 'privilege');
			});
			utils.map(privileges.unchecked, function (privilege) {
				return self.getNodeIndex(privilege, 'privilege');
			});

			// update privilege info if necessary
			privilegeInfo.nrOfPrivileges        = utils.collectionSize(self.registry[0].tree.resourceData.treeData.nodes);
			privilegeInfo.nrOfRolePrivileges    = utils.collectionSize(rolePrivileges);
			privilegeInfo.nrOfUserPrivileges    = utils.collectionSize(userPrivileges);

			self.checkNodes(privileges.checked, treeComponentIndex, autoSelect);
			self.uncheckNodes(privileges.unchecked, treeComponentIndex, autoSelect);

			return privilegeInfo;
		},

		isBlackListPrivilege: function(privilegeCode){
			var index, privileges;
			return ((index = (privileges = (privilegeCode || '').split(':')).indexOf('attributes')) > -1 && index < privileges.length - 1);
		},

		// TODO: DOC!
		onTreeAction: function (data) {
			var self = this;

			switch (data.onTreeActionOptions.eventType) {
				case 'changed.jstree':
					if(!data.onTreeActionOptions.autoSelect || (this.config.decisionOptions && this.config.decisionOptions.decideOnAutoSelect)) {
						var allNodes = self.registry[0].tree.resourceData.treeData.nodes;
						var checkedNodes = this.getCheckedNodes();
						var privileges = [];
						var checked, isBlackListElement;
						utils.forEach(allNodes, function(nodeData){
							checked = utils.indexOf(checkedNodes, nodeData.index) > -1;
							isBlackListElement = self.isBlackListPrivilege(nodeData.code);

							if(
								(checked && !isBlackListElement)
								||
								(!checked && isBlackListElement)
							){
								privileges.push(nodeData);
							}
						});

						// TODO: impl. animation and animation-delay
						// show page actions if necessary
						this.triggerClosest('onDecision', {
							decisionComponent: self,
							decisionType: 'submit',
							decisionOptions: self.config.decisionOptions || {},
							data: privileges
						});
					}
					break;
			}
		}
	},

	// NOTE: prevent privilegeTrees handlers from being called for this selectPrivilegeTrees-Component
	handlers: undefined
};
